import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import ChecklistElement from './ChecklistElementModel';
import Checkbox from '@mui/material/Checkbox';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import { Typography } from '@mui/material';
import { QuickTextInput } from 'shouldve-been-mui';

class SimpleChecklistElement extends ChecklistElement {

    private _hasCheckbox: boolean;
    private _hasComment: boolean;
    private _isBold: boolean;

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number, hasCheckbox: boolean, hasComment: boolean, isBold: boolean) {

        super(elementId, name, itemNumber, sortNumber, EditorType.SIMPLE_CHECKLIST);
        this._hasCheckbox = hasCheckbox;
        this._hasComment = hasComment;
        this._isBold = isBold;
    }

    public get hasCheckbox(): boolean {
        return this._hasCheckbox;
    }

    public set hasCheckbox(value: boolean) {
        this._hasCheckbox = value;
    }

    public get hasComment(): boolean {
        return this._hasComment;
    }

    public set hasComment(value: boolean) {
        this._hasComment = value;
    }

    public get isBold(): boolean {
        return this._isBold;
    }

    public set isBold(value: boolean) {
        this._isBold = value;
    }

    public buildFormElement(value: boolean, comment: string, onChange: (value: boolean) => Promise<void>, onCommentBlur: (value: string) => Promise<void>, signName: string, signDateString: string, primaryTextColor: string, screenWidth: number): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <div style={{
                    border: '1px solid #777777',
                    borderRadius: '15px',
                    padding: this.hasCheckbox //as the formcontrollabels introduce some weird extra paddings, this makes all paddings look the same anyway
                        ? value || this.hasComment
                            ? '5px 14px 14px 14px'
                            : '5px 14px'
                        : '14px',
                    width: Math.min(screenWidth * 0.8, 500),
                }}>
                    {this.hasCheckbox
                        ? (
                            <>
                                <FormControlLabel
                                    control={
                                        <div style={{
                                            display: 'table-cell',
                                        }}>
                                            <Checkbox
                                                color='primary'
                                                checked={value}
                                                onChange={async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => onChange(e.target.checked)}
                                            />
                                        </div>
                                    }
                                    label={
                                        <span style={{
                                            color: primaryTextColor,
                                            fontWeight: this.isBold ? 'bold' : undefined,
                                        }}>
                                            {(this.itemNumber === null ? '' : (this.itemNumber + '. ')) + this.name}
                                        </span>
                                    }
                                    style={{
                                        display: 'table',
                                    }}
                                />
                                {this.hasComment &&
                                    <div style={{
                                        marginTop: '10px',
                                    }}>
                                        <QuickTextInput
                                            value={comment}
                                            onBlur={onCommentBlur}
                                            variant='outlined'
                                            dense={true}
                                            minWidth='100%'
                                            maxWidth='100%'
                                            labelText='Comment'
                                            height='40px'
                                        />
                                    </div>
                                }
                                {value &&
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                        marginTop: this.hasComment ? '10px' : undefined,
                                    }}>
                                        <Typography style={{
                                            color: primaryTextColor,
                                        }}>
                                            {signName}
                                        </Typography>
                                        <Typography style={{
                                            color: primaryTextColor,
                                        }}>
                                            {signDateString}
                                        </Typography>
                                    </div>
                                }
                            </>
                        )
                        : (
                            <>
                                <span style={{
                                    color: primaryTextColor,
                                    fontWeight: this.isBold ? 'bold' : undefined,
                                }}>
                                    {(this.itemNumber === null ? '' : (this.itemNumber + '. ')) + this.name}
                                </span>
                                {this.hasComment &&
                                    <div style={{
                                        marginTop: '15px',
                                    }}>
                                        <QuickTextInput
                                            value={comment}
                                            onBlur={onCommentBlur}
                                            variant='outlined'
                                            dense={true}
                                            minWidth='100%'
                                            maxWidth='100%'
                                            labelText='Comment'
                                            height='40px'
                                        />
                                    </div>
                                }
                            </>
                        )
                    }
                </div>
                <br />
            </React.Fragment>
        );
    }
}

export default SimpleChecklistElement;